export default __webpack_public_path__ + "static/media/date.7666c739.svg";